export const FETCH_CONTACTS = "FETCH_CONTACTS"
export const FETCH_CONTACT = "FETCH_CONTACT"
